export default __webpack_public_path__ + "static/media/ozkeySplash.4c67935b.webp";